import { Notifier } from '@airbrake/browser'
import Rails from '@rails/ujs'
import * as Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "../channels"
import "../controllers"
import "../bootstrap_components/init_components"

Turbolinks.start()
ActiveStorage.start()
Rails.start()

let airbrakeInfo = document.getElementById('airbrake-info')
if (airbrakeInfo) {
  let options = {
    projectId: airbrakeInfo.getAttribute('data-project-id'),
    projectKey: airbrakeInfo.getAttribute('data-project-key'),
    environment: airbrakeInfo.getAttribute('data-env'),
    remoteConfig: false,
    performanceStats: false,
    queryStats: false,
    queueStats: false
  }
  let host = airbrakeInfo.getAttribute('data-host')
  if (host) { options['host'] = host }
  let airbrake = new Notifier(options)

  window.airbrake = airbrake
}
